/**
 * Card-sizer wiring for the Category Card Elementor widget — same shape as
 * elementor-manual-card.js. See project memory "Elementor custom widget JS
 * init pattern" for why this specific `frontend/element_ready` +
 * `elementor/frontend/init` shape is required.
 */
( function () {
	'use strict';

	function registerElementReadyHook() {
		window.elementorFrontend.hooks.addAction( 'frontend/element_ready/gws-category-card.default', function ( $scope ) {
			var card = $scope[ 0 ].querySelector( '.gws-card' );

			if ( card && window.GWSInitCardSizer ) {
				window.GWSInitCardSizer( card );
			}
		} );
	}

	if ( window.elementorFrontend && window.elementorFrontend.hooks ) {
		registerElementReadyHook();
	} else {
		window.addEventListener( 'elementor/frontend/init', registerElementReadyHook );
	}
} )();
